<template>
  <h3 class="ttl">
    <div>
      <span class="emp">{{ titleLabel[type] }}</span>
      (총 <span class="error">{{ count }}</span
      >개 검색 결과)
    </div>
    <div class="more pnt" @click="viewMore">
      더보기<i class="i_ar_my_set_g"></i>
    </div>
  </h3>
</template>
<script>
export default {
  name: 'component-search-result-title',
  description: '검색 결과 타이틀',
  props: {
    type: String,
    count: Number,
  },
  data() {
    return {
      titleLabel: {
        STORE: '매장',
        KNOWHOW: '퍼뮤니티',
        BOARD: '자유게시판',
        REVIEW: '리뷰',
      },
    };
  },
  methods: {
    viewMore() {
      this.$emit('more', this.type);
    },
  },
};
</script>
